import { ErrorHandler as AngularErrorHandler, Injectable } from '@angular/core';
import { LogService } from '@shared/services/log/log.service';

@Injectable({ providedIn: 'root' })
export class ErrorHandler implements AngularErrorHandler {

  constructor(private logService: LogService) { }

  handleError(err: any): void {
    this.logService.logError(err);
  }
}

